//  It will show either images or videos on internet speed. 
$(window).on('load', function(){ 
    let downloadSize = 5616998; 
    let downloadImgSrc = new Image();
    
    downloadImgSrc.onload = function () {
        let end_time = new Date().getTime();
        displaySpeed(end_time);
    };
    let time_start = new Date().getTime();
    // downloadImgSrc.src = "https://media.geeksforgeeks.org/wp-content/cdn-uploads/20200714180638/CIP_Launch-banner.png";
    downloadImgSrc.src = "https://cdn.shopify.com/s/files/1/0279/9917/4716/files/NEW_ARRIVALS_1_2297ab10-1e0f-4161-a816-31167cb76014.png?v=1717796338";
    
    function displaySpeed(end_time) {
        let timeDuration = (end_time - time_start) / 1000;
        let loadedBits = downloadSize * 8;
    
        let bps = (loadedBits / timeDuration).toFixed(2);
        let speedInKbps = (bps / 1024).toFixed(2);
        let speedInMbps = (speedInKbps / 1024).toFixed(2);
        speedInKbps = +speedInKbps; 
        speedInMbps = +speedInMbps;

        console.log(bps + "bps" + speedInKbps + "kbps" + speedInMbps + "mbps");
        console.log(speedInMbps > 280 || speedInKbps >  280000)  
        var block_image_video =  $('.block__image_video')
        block_image_video.each(function(key, value){
            if(speedInMbps > 280 || speedInKbps >  280000){
                jQuery(block_image_video[key]).children('img').remove();
                jQuery(block_image_video[key]).children('video').css('opacity', 1)

            }else{
                jQuery(block_image_video[key]).children('video').remove();
                jQuery(block_image_video[key]).children('img').addClass('active')
            }
        });    
    }
});